import { render, staticRenderFns } from "./loginOtp.vue?vue&type=template&id=05fb75c7&scoped=true"
import script from "./loginOtp.vue?vue&type=script&lang=js"
export * from "./loginOtp.vue?vue&type=script&lang=js"
import style0 from "./loginOtp.vue?vue&type=style&index=0&id=05fb75c7&prod&lang=sass&scoped=true"
import style1 from "./loginOtp.vue?vue&type=style&index=1&id=05fb75c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb75c7",
  null
  
)

export default component.exports